<template>
  <div>
    <div>
      <Row class="expand-row">
        <Col span="24">
          <span class="expand-key">JSON: </span>
          <span class="expand-value">{{ row.json }}</span>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      row: Object
    }
  };
</script>
<style scoped>
  .expand-row{
    padding-left: 17px;
    margin-bottom: 10px;
  }
  .expand-key
  {
    display: block;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/iam_config/policy/TableExpand.vue